import get from 'lodash.get';
import { emptyArray } from 'ui-components/default-props/empty';

export const selectByFulfillmentPlanId = (state, props) => get(state, `${props.fulfillmentPlanId}`);
export const selectShippingConfiguration = (state, props) => get(selectByFulfillmentPlanId(state, props), 'shippingConfiguration');
export const selectPackages = (state, props) => get(selectShippingConfiguration(state, props), 'packages', emptyArray);
export const selectFulfillmentServiceId = (state, props) => get(selectShippingConfiguration(state, props), 'fulfillmentServiceId');
export const selectOverrideShipmentItems = (state, props) => get(selectByFulfillmentPlanId(state, props), 'overrideShipment.items');
export const selectPackingSlipTemplateId = (state, props) => get(selectShippingConfiguration(state, props), 'packingSlipTemplateId');
export const selectShipmentTemplateId = (state, props) =>
  get(selectShippingConfiguration(state, props), 'shipmentEmailNotificationTemplateId');
export const selectDeliveryTemplateId = (state, props) =>
  get(selectShippingConfiguration(state, props), 'deliveryEmailNotificationTemplateId');

export const selectOptions = (state, props) => get(selectShippingConfiguration(state, props), 'options');

export const selectCustoms = (state, props) => get(selectShippingConfiguration(state, props), 'customs');

export const selectTypeId = (state, props) => {
  const typeId = get(selectByFulfillmentPlanId(state, props), 'type');
  return typeId;
};
export const selectIsReturn = (state, props) => get(selectByFulfillmentPlanId(state, props), 'isReturn', false);
